import { render, staticRenderFns } from "./group-friend.vue?vue&type=template&id=7922d4ea&"
import script from "./group-friend.js?vue&type=script&lang=js&"
export * from "./group-friend.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports